const useHandleMenuOptionSelect = ({
    onSubmit,
    fetchProductCookie,
    handleSetMessage,
    scrollToBottom,
    setShowFormQuote,
    setShowFormCallback,
    setShowFormSupplier,
    setIsInputDisabled,
    setIsMenuDisabled,
    setMessages,
    isLoggedIn,
    addGetQuotes,
    setHideChiclets
}) => {
    return async (option) => {
        handleSetMessage(option, "user");
        handleSetMessage("Loading...", "system");
        setIsInputDisabled(true);
        setIsMenuDisabled(true);
        setHideChiclets(true);
        setTimeout(() => {
            scrollToBottom();
        }, 100);

        if (option === "get quotes") {
            if (!isLoggedIn) {
                handleSetMessage("Please login to access this functionality", "system");
                setIsMenuDisabled(false);
                setIsInputDisabled(false);
            } else {
                await fetchProductCookie();
                setShowFormQuote(true);
                setIsInputDisabled(true);
            }
            setMessages((prevMessages) =>
                prevMessages.filter((msg) => msg.text !== "Loading...")
            );
        } else if (option === "become a supplier") {
            if (!isLoggedIn) {
                handleSetMessage("Please login to access this functionality", "system");
                setIsMenuDisabled(false);
                setIsInputDisabled(false);
            } else {
                setShowFormSupplier(true);
                setIsInputDisabled(true);
            }
            setMessages((prevMessages) =>
                prevMessages.filter((msg) => msg.text !== "Loading...")
            );
        } else {
            try {
                const res = await onSubmit(option);
                const processedOutput = addGetQuotes(res.output);
                handleSetMessage(processedOutput, "system");
                setIsInputDisabled(false);
                setIsMenuDisabled(false);
                setMessages((prevMessages) =>
                    prevMessages.filter((msg) => msg.text !== "Loading...")
                );
            } catch (error) {
                console.error("Error in handleMenuOptionSelect:", error);
                handleSetMessage("Failed to get response. Please try again later.", "system");
                setIsInputDisabled(false);
                setMessages((prevMessages) =>
                    prevMessages.filter((msg) => msg.text !== "Loading...")
                );
            } finally {
                setTimeout(() => {
                    scrollToBottom();
                }, 100);
            }
        }
    };
};

export default useHandleMenuOptionSelect;
